<template>
<div class="relative rounded-32" :class="[ button ? 'cursor-pointer' : '' ]" @click="$emit('click')">
    <svg-icon
        type="sentiment-satisfied"
        class="w-full h-full fill-semantic-warning"
    />
</div>
</template>

<script>
import SvgIcon from '../SvgIcon.vue';
export default {
    components: {
        SvgIcon,
    },
    props: {
        button: Boolean,
        active: Boolean,
    }
}
</script>
